import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

function IconsHospitalNavbar({ setSearchModal }) {
  const [isSticky, setIsSticky] = useState(false);
  const patientLogin = useSelector((state) => state.patient.patientLogin);
  const sitedata = useSelector((store) => store.global.loginData);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="sticky-outer full-dark">
      <div className={`sticky-head ${isSticky ? "header-sticky" : ""}`}>
        <nav className="navbar">
          <div className="basic-container clearfix">
            <div className="navbar-inner center-header-navlinks-hover">
              <ul className="nav navbar-items pull-left">
                <li className="list-item">
                  <Link
                    to={"/"}
                    className="logo-general d-flex align-items-center gap-1"
                  >
                    <img
                      src={
                        sitedata?.site_logo
                          ? `${sitedata?.site_logo}`
                          : "/assets/img/hospital-static.jpg"
                      }
                      alt="Logo"
                      style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "10px",
                        marginTop: "5px",
                      }}
                    />
                    <h5 className="mb-0">
                     {sitedata.site_type !== "hospitals" && sitedata?.site_title ? (
                        <span>{"Dr. " + sitedata.site_title}</span>
                      ) : (
                        sitedata?.site_title || ""
                      )}
                    </h5>
                  </Link>
                </li>
              </ul>
              <ul className="nav navbar-items pull-right">
                <li className="list-item">
                  <ul className="nav navbar-main theme-main-menu">
                    <li className="menu-item">
                      <Link to={"/"}>
                        <i class="fa-solid fa-house"></i> Home
                      </Link>
                    </li>
                    <li className="menu-item">
                      <Link to={"/about"}>
                        <i class="fa-solid fa-users"></i> About Us
                      </Link>
                    </li>
                    <li class="dropdown menu-item dropdown-sub">
                      <a>
                        <i class="fa-solid fa-bed-pulse"></i> Patient Care
                      </a>
                      <ul class="dropdown-menu">
                        <li>
                          <Link to={"/doctors"}>
                            <i class="fa-solid fa-user-doctor"></i> Doctors
                          </Link>
                          <Link to={"/specialities"}>
                            <i class="fa-solid fa-stethoscope"></i> Specialties
                          </Link>
                          <Link to={"/facilities"}>
                            <i class="fa-solid fa-house-medical"></i> Facilities
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li class="dropdown menu-item dropdown-sub">
                      <a>
                        <i class="fa-solid fa-photo-film"></i> Media
                      </a>
                      <ul class="dropdown-menu">
                        <li>
                          <Link to={"/blogs"}>
                            <i class="fa-solid fa-image"></i> Blogs
                          </Link>
                          <Link to={"/news"}>
                            <i class="fa-solid fa-newspaper"></i> News & Update
                          </Link>
                          {sitedata?.permissions?.review !== "hide" && (
                            <Link to={"/reviews"}>
                              <i class="fa-solid fa-star"></i> Reviews
                            </Link>
                          )}
                          <Link to={"/gallery"}>
                            <i class="fa-solid fa-images"></i>{" "}
                            Gallery
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li class="dropdown menu-item dropdown-sub">
                      <a>
                        <i class="fa-solid fa-user-plus"></i> Careers
                      </a>
                      <ul class="dropdown-menu">
                        <li>
                          <Link to={"/careers"}>
                            <i class="fa-solid fa-users"></i> Job Openings
                          </Link>
                          <Link to={"/drop-cv"}>
                            <i class="fa-solid fa-file-arrow-down"></i> Drop Your CV
                          </Link>
                        </li>
                      </ul>
                    </li>

                    <li className="menu-item">
                      <Link to={"/feedback"}>
                        <i class="fa-solid fa-comment-dots"></i> Feedback
                      </Link>
                    </li>
                    <li className="menu-item">
                      <Link to={"/contact"}>
                        <i class="fa-solid fa-phone-volume"></i> Contact Us
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="list-item Login-btn-new-theme">
                  {patientLogin ? (
                    <Link to="/patient">My Account</Link>
                  ) : (
                    <Link to="/login">Login</Link>
                  )}
                </li>

                {/* <li className="list-item">
                  <span
                    onClick={() => setSearchModal(true)}
                    className="full-view-switch text-center"
                  >
                    <i className="ti-search typo-dark"></i>
                  </span>
                 
                </li> */}
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
}

export default IconsHospitalNavbar;
